import { storeUserData, loadUserData, storeUserAndPlanSituation, loadUserAndPlanSituation, storeUserCards, loadUserCards } from './store'
import { buildWatchError } from '@/common/watch-error'

const storeUserDataMixin = {
  methods: {
    /**
     * @param {Object} data
     */
    storeUserData (data) {
      return storeUserData(data)
    },
    /**
     * @param {AcaoPermitidaParaPlanoEscolhidoEnum} action
     */
    storeUserAndPlanSituation (action) {
      return storeUserAndPlanSituation(action)
    },
    /**
     * @param {Array<Object>} cards
     */
    storeUserCards (cards) {
      return storeUserCards(cards)
    }
  }
}

const loadUserDataMixin = {
  data: () => ({
    userDataError: false,
    userData: {
      cpf: '',
      msisdn: ''
    },
    userCards: []
  }),
  userDataError: buildWatchError('onUserDataError'),
  methods: {
    loadUserData () {
      return loadUserData()
        .then(data => {
          this.userData = data
        })
        .catch(err => {
          this.$tracker.error(err)
          this.userDataError = err.message
        })
    },
    async loadUserAndPlanSituation () {
      const action = await loadUserAndPlanSituation()
      this.userOfferSituation = action
    },
    async loadUserCards () {
      const cards = await loadUserCards()
      this.userCards = cards ?? []
    }
  },
  mounted () {
    this.loadUserData()
  }
}

export { storeUserDataMixin, loadUserDataMixin }
